import { createSlice } from "@reduxjs/toolkit";

import {
    SET_APP_START,
    LOADING,
    AUTH_FORM,
    REGISTRATION_FORM,
    RECOVERY_PASSWORD_FORM,
    CHECK_EMAIL_FORM,
    BOOKING,
    FILTERS,
    EST,
    SET_USER_BAR,
    SET_USER,
    SET_SUBSCRIPTIONS,
    SET_SCHEDULE,
    SET_SCHEDULE_ACTIVE,
    SET_MY_RESERVES,
    SET_MOBILE_MENU,
    SET_CHOICE_ADDRESS_FROM,
    SET_COACH_INFO
} from "./types";

import {
    AUTH_FORM_INITIAL,
    BOOKING_INITIAL,
    CHECK_EMAIL_FORM_INITIAL,
    FILTERS_INITIAL,
    RECOVERY_PASSWORD_FORM_INITIAL,
    REGISTRATION_FORM_INITIAL,
    USER_INITIAL,
    SCHEDULE_INITIAL,
    MY_RESERVES_INITIAL,
    CHOICE_ADDRESS_FORM_INITIAL,
    COACH_INFO_INITIAL
} from './initialStateConstants';

const initialState = {
    app_start: false,
    loading: false,
    auth_form: AUTH_FORM_INITIAL,
    registration_form: REGISTRATION_FORM_INITIAL,
    recovery_password_form: RECOVERY_PASSWORD_FORM_INITIAL,
    check_email_form: CHECK_EMAIL_FORM_INITIAL,
    booking: BOOKING_INITIAL,
    filters: FILTERS_INITIAL,
    est: {
        slug: '',
        id: ''
    },
    user_bar: false,
    user: USER_INITIAL,
    subscriptions: [],
    schedule: SCHEDULE_INITIAL,
    schedule_active: false,
    my_reserves: MY_RESERVES_INITIAL,
    mobile_menu: false,
    choice_address_form: CHOICE_ADDRESS_FORM_INITIAL,
    coach_info: COACH_INFO_INITIAL,
    registration_docs: []
};

const rootReducer = createSlice({
    name: 'reducer',
    initialState,
    reducers: {
        setRegistrationDocsAction: (state, action) => { state.registration_docs = action.payload }
    },
    extraReducers: (builder) => {
        // конвертируем старые экшены в обработчики
        builder
            .addCase(SET_APP_START, (state, action) => { state.app_start = action.data; })
            .addCase(LOADING, (state, action) => { state.loading = action.data; })
            .addCase(AUTH_FORM, (state, action) => { state.auth_form = action.data; })
            .addCase(REGISTRATION_FORM, (state, action) => { state.registration_form = action.data; })
            .addCase(RECOVERY_PASSWORD_FORM, (state, action) => { state.recovery_password_form = action.data; })
            .addCase(CHECK_EMAIL_FORM, (state, action) => { state.check_email_form = action.data; })
            .addCase(BOOKING, (state, action) => { state.booking = action.data; })
            .addCase(FILTERS, (state, action) => { state.filters = action.data; })
            .addCase(EST, (state, action) => { state.est = action.data; })
            .addCase(SET_USER_BAR, (state, action) => { state.user_bar = action.data; })
            .addCase(SET_USER, (state, action) => { state.user = action.data; })
            .addCase(SET_SUBSCRIPTIONS, (state, action) => { state.subscriptions = action.data; })
            .addCase(SET_SCHEDULE, (state, action) => { state.schedule = action.data; })
            .addCase(SET_SCHEDULE_ACTIVE, (state, action) => { state.schedule_active = action.data; })
            .addCase(SET_MY_RESERVES, (state, action) => { state.my_reserves = action.data; })
            .addCase(SET_MOBILE_MENU, (state, action) => { state.mobile_menu = action.data; })
            .addCase(SET_CHOICE_ADDRESS_FROM, (state, action) => { state.choice_address_form = action.data; })
            .addCase(SET_COACH_INFO, (state, action) => { state.coach_info = action.data; });
    }
});

export const reducer = rootReducer.reducer;

export const {
    setRegistrationDocsAction
} = rootReducer.actions;